import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import get from 'lodash/get';

import ExpirationDate from '@src/custom/expiration-date';
import CopyImageURLButton from './copy-image-url-button';

const StyledItem = styled(Grid)({
    display: 'flex',
});

const StyledCard = styled(Card)({
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'space-between',
    'height': '100%',
    'transition': 'transform .2s',
    '&:hover': {
        transform: 'scale(1.025)',
    },
});

const StyledMediaContainer = styled('div')({
    background: `
        linear-gradient(45deg, #f5f5f5 25%, transparent 25%),
        linear-gradient(-45deg, #f5f5f5 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #f5f5f5 75%),
        linear-gradient(-45deg, transparent 75%, #f5f5f5 75%)
    `,
    backgroundSize: '16px 16px',
    backgroundPosition: '0 0, 0 8px, 8px -8px, -8px 0px',
});

const StyledMedia = styled(CardMedia)({
    'height': 0,
    'paddingTop': '56.25%', // 16:9
    '&:hover': {
        cursor: 'pointer',
    },
});

const StyledLink = styled(Typography)({
    wordWrap: 'break-word',
});

const ImageChooserItem = (props) => {
    const { image, showCopy, onClick } = props;

    const handleImageClick = useCallback((e) => {
        e.preventDefault();
        onClick(image);
    }, [onClick, image]);

    return (
        <StyledItem
            size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3,
            }}
        >
            <StyledCard>
                <StyledMediaContainer>
                    <StyledMedia
                        height="140"
                        image={image.source}
                        title={image.alt}
                        onClick={handleImageClick}
                    />
                </StyledMediaContainer>
                <CardContent>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        // component="p"
                        component={StyledLink}
                    >
                        {image.alt}
                    </Typography>
                    <ExpirationDate expiredAt={get(image, 'expired_at')} />
                </CardContent>
                {
                    showCopy ?
                        <CardActions>
                            <CopyImageURLButton image={image} />
                        </CardActions> :
                        null
                }
            </StyledCard>
        </StyledItem>
    );
};

ImageChooserItem.propTypes = {
    image: PropTypes.shape({
        id: PropTypes.number.isRequired,
        source: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    }).isRequired,
    showCopy: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default React.memo(ImageChooserItem);
